// @ts-nocheck
import React, { useState } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

import { Duration } from 'moment';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails } from 'models/travelDetails';

import CancelPendingTrip from '../CancelPendingTrip';
import TripCardHelp from '../TripCardHelp';
import Cancelled from './Cancelled';
import Confirmed from './Confirmed';
import ErrorAtSending from './ErrorAtSending';
import Expired from './Expired';
import Pending from './Pending';
import Reproved from './Reproved';
import { Message, RequestStatusInfoWrapper } from './styles';

type Props = {
  travelId: string;
  status: string;
  travelDetails: TravelDetails;
  expirationTime: Duration;
  isExpiring: boolean;
  isAir: boolean;
};

function statusComponent({ status, travelDetails, isAir, setHelp }) {
  switch (status) {
    case 'Pending':
      return <Pending travelDetails={travelDetails} setHelp={setHelp} />;
    case 'PreApproved':
      return <Pending travelDetails={travelDetails} setHelp={setHelp} />;
    case 'Approved':
      return <Pending travelDetails={travelDetails} setHelp={setHelp} />;
    case 'Confirmed':
      return <Confirmed isAir={isAir} travelDetails={travelDetails} setHelp={setHelp} />;
    case 'Reproved':
      return <Reproved />;
    case 'Expired':
      return <Expired />;
    case 'Cancelled':
      return <Cancelled />;
    case 'ErrorAtSending':
      return <ErrorAtSending />;

    default:
      return <></>;
  }
}

const RequestStatusInfo = ({ travelId, ...props }: Props) => {
  const { t } = useStoreTranslation();
  const [help, setHelp] = useState('');

  const helpComponent = (item: string) => {
    switch (item) {
      case 'cancelPending':
        return <CancelPendingTrip travelId={travelId} onBack={() => setHelp('')} />;
      case 'changePending':
        return <CancelPendingTrip messageMode="change" travelId={travelId} onBack={() => setHelp('')} />;
      case 'cancelConfirmed':
        return (
          <TripCardHelp
            withContactButtons
            title={t('customerSupport.cancelReservation.helpTitle')}
            onBack={() => setHelp('')}
          >
            <Message>{t('customerSupport.cancelReservation.message')}</Message>
          </TripCardHelp>
        );
      case 'changeConfirmed':
        return (
          <TripCardHelp
            withContactButtons
            title={t('customerSupport.changeReservation.helpTitle')}
            onBack={() => setHelp('')}
          >
            <Message>{t('customerSupport.changeReservation.message')}</Message>
          </TripCardHelp>
        );

      default:
        return <></>;
    }
  };

  return (
    <SwitchTransition>
      <CSSTransition
        key={help}
        addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
        classNames="fade"
      >
        {help ? (
          helpComponent(help)
        ) : (
          <RequestStatusInfoWrapper>{statusComponent({ ...props, setHelp })}</RequestStatusInfoWrapper>
        )}
      </CSSTransition>
    </SwitchTransition>
  );
};

export default RequestStatusInfo;
